import { useRouteError } from "react-router-dom";

import GenericError  from 'pages/ErrorPage/GenericError';
import Grid          from '@mui/material/Grid';
import NotFoundError from 'pages/ErrorPage/NotFoundError';

export default function ErrorPage() {

  const error = useRouteError();
  console.error(error);

  let errorElement = <GenericError error={error}/>

  if (error.status === 404)
    errorElement = <NotFoundError/>


  return (
    <Grid container justifyContent='center'>
      <Grid item>
        {errorElement}
      </Grid>
    </Grid>
  );
}